import React from 'react';

const IconFavorites = () => {
  return (
    <svg
      width="15"
      height="14"
      viewBox="0 0 15 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.82189 1.57673L8.82198 1.57681L8.82932 1.56853C10.0867 0.150015 12.1981 0.13625 13.5332 1.57269C14.8273 3.03722 14.816 5.39638 13.5369 6.77667L7.52492 13.2644L1.51292 6.77667L1.51301 6.77658L1.50529 6.76861C0.168963 5.38924 0.158299 3.03854 1.51292 1.57673L1.51301 1.57681L1.52035 1.56853C2.77888 0.148687 4.89307 0.136226 6.22794 1.57673L7.15817 2.58057L7.52492 2.97633L7.89166 2.58057L8.82189 1.57673Z"
        stroke="white"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default IconFavorites;
